module.exports = __webpack_public_path__ + "static/media/bootstrap.53b32f2e.svg";